"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// dummy capability, the code handles both single and multiple prefixes just fine
var MultiPrefixCapability = {
    name: 'multi-prefix'
};
exports.default = MultiPrefixCapability;
//# sourceMappingURL=MultiPrefixCapability.js.map